/**
 * Keys and patterns aligned with compliance: strip before Sentry upload and from structured logs.
 */
export const SENSITIVE_KEY_PATTERN =
  /password|passwd|passphrase|secret|token|api[_-]?key|authorization|auth|cookie|ssn|social|tax[_-]?id|ein|routing|account|iban|cvv|card|phone|mobile|dob|date[_-]?of[_-]?birth|birthdate|license|passport|document[_-]?url|bank[_-]?statement|w-?2|pii/i;

export function isSensitiveKey(key: string): boolean {
  return SENSITIVE_KEY_PATTERN.test(key);
}

/**
 * Deep-redact known sensitive keys in arbitrary JSON-like data for Sentry logs / breadcrumbs.
 */
export function redactStructuredData(value: unknown): unknown {
  if (value === null || value === undefined) return value;
  if (Array.isArray(value)) {
    return value.map((item) => redactStructuredData(item));
  }
  if (typeof value === "object") {
    const entries = Object.entries(value as Record<string, unknown>).map(
      ([k, v]) =>
        [k, isSensitiveKey(k) ? "[REDACTED]" : redactStructuredData(v)] as const,
    );
    return Object.fromEntries(entries);
  }
  return value;
}
